export default __webpack_public_path__ + "static/media/MeineBestellungen.7ed249ef.jpg";